import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@fiverr-private/modal/src';
import classNames from 'classnames';
import getRenderable from '@fiverr-private/fit/lib/getRenderable';

import ContentWrapper from './ContentWrapper';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import isFunction from './Utils/isFunction';

import './style.scss';

class Summary extends Modal {
    constructor(props) {
        super(props);

        this.headerOnClick = this.headerOnClick.bind(this);
    }

    headerOnClick() {
        isFunction(this.close) && this.close();
        setTimeout(
            () => this.props.onClickCloseButton && this.props.onClickCloseButton(),
            200);
    }

    __view(props) {

        const {
            header,
            footer,
            children,
            hasCloseBtn,
            className
        } = this.props;

        const contentWrapperClasses = classNames('modal-summary-wrapper', className);

        return (
            <ContentWrapper {...props} className={contentWrapperClasses}>
                {header && <Header hasCloseBtn={hasCloseBtn} onClick={this.headerOnClick}>{getRenderable(header, props)}</Header>}
                {children && <Body>{getRenderable(children, props)}</Body>}
                {footer && <Footer>{getRenderable(footer, props)}</Footer>}
            </ContentWrapper>
        );
    }
}

Summary.propTypes = {
    header: PropTypes.any,
    footer: PropTypes.any,
    children: PropTypes.any,
    hasCloseBtn: PropTypes.bool,
    onClickCloseButton: PropTypes.func
};

Summary.defaultProps = {
    closeOnEscape: false,
    bindBodyClickListener: false
};

export default Summary;
